import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { StructuredData } from "@/components/StructuredData";
import { Hero } from "@/components/site/Hero";
import { ClientLogos } from "@/components/site/ClientLogos";
import { ProblemSolution } from "@/components/site/ProblemSolution";
import { HowItWorksVisual } from "@/components/site/HowItWorksVisual";
import { RoiCalculator } from "@/components/site/RoiCalculator";
import { Comparison } from "@/components/site/Comparison";
import { CtaBand } from "@/components/site/CtaBand";
import { SiteLayout } from "@/components/site/SiteLayout";
import { baseSiteSchemaGraph, videoObjectSchema } from "@/lib/seoSchema";
import {
  buildEmbeddedAppPath,
  isEmbeddedShopifyLaunch,
  openShopifyTopLevel,
  setShopifyEmbeddedContext,
} from "@/lib/shopifyEmbedded";

function Index() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const shop = searchParams.get("shop");
    const host = searchParams.get("host");
    const embedded = searchParams.get("embedded");
    const isEmbeddedLaunch = isEmbeddedShopifyLaunch(searchParams);

    if (shop && shop.includes(".myshopify.com")) {
      setShopifyEmbeddedContext({
        embedded: embedded === "1" || Boolean(host),
        host,
        shop,
      });

      if (isEmbeddedLaunch) {
        const params = new URLSearchParams();
        params.set("platform", "shopify");
        params.set("tab", "signup");
        params.set("shop", shop);
        if (host) params.set("host", host);
        if (embedded === "1" || host) params.set("embedded", "1");

        navigate(buildEmbeddedAppPath("/merchant-login", params), { replace: true });
        return;
      }

      const oauthUrl = new URL(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/shopify-oauth-init`);
      oauthUrl.searchParams.set("shop", shop);
      if (host) oauthUrl.searchParams.set("host", host);
      openShopifyTopLevel(oauthUrl.toString());
    }
  }, [navigate, searchParams]);

  return (
    <SiteLayout>
      <SEO
        title="Splitkart: Group Gifting & Split Payments for Shopify"
        description="Make group gifting easy with Splitkart. Let customers split high-ticket orders at checkout to boost AOV and reach new shoppers instantly."
        url="/"
      />
      <StructuredData data={[baseSiteSchemaGraph(), videoObjectSchema()]} />
      <Hero />
      <ClientLogos />
      <ProblemSolution />
      <HowItWorksVisual />
      <RoiCalculator />
      <Comparison />
      <CtaBand />
    </SiteLayout>
  );
}

export default Index;
